export const GOOGLE_DV360_DSP_ID = 5113;
export const TTD_DSP_ID = 5130;
export const TTD_ADVERTISER_SEAT_PREFIX = 'adv';
